module.exports = __webpack_public_path__ + "img/qj.c9101b80.jpg";